import { useMemo } from 'react';

import { authenticatedSwrOptions } from 'src/utils/constants';

import { zerreactorBackendEndpoints } from 'src/api/services/zerreactor_backend_definition/zerreactorBackendEndpoints';

import useAuthenticatedSWR from 'src/auth/hooks/use-authenticated-swr';



export function useGetUserNotificationReceipents() {
    const { data, isLoading, error, isValidating } = useAuthenticatedSWR(zerreactorBackendEndpoints.Admin.userNotificationReceipents, authenticatedSwrOptions);

    return useMemo(() => ({
        users: data || [],
        usersLoading: isLoading,
        usersError: error,
        usersValidating: isValidating,
    }), [data, isLoading, error, isValidating]);
}

export function useGetParticipantNotificationReceipents() {
    const { data, isLoading, error, isValidating } = useAuthenticatedSWR(zerreactorBackendEndpoints.Admin.participantNotificationReceipents, authenticatedSwrOptions);

    return useMemo(() => ({
        participants: data || [],
        participantsLoading: isLoading,
        participantsError: error,
        participantsValidating: isValidating,
    }), [data, isLoading, error, isValidating]);
}